import { render, staticRenderFns } from "./CircleShader.vue?vue&type=template&id=b06ba5d6&"
import script from "./CircleShader.vue?vue&type=script&lang=js&"
export * from "./CircleShader.vue?vue&type=script&lang=js&"
import style0 from "./CircleShader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports